"use client";  

import dynamic from "next/dynamic";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BlogsBannerComponent = dynamic(() => import("../BlogsBannerComponent/BlogsBannerComponent"), {
    ssr: false,
    loading: () => (
      <Skeleton 
        height="85vh" 
        width="90vw"
      />
    ),
  });
const FooterComponent = dynamic(() => import("../Footer/Footer"), {
    ssr: false,
    loading: () => (
      <Skeleton 
        height="80vh" 
        width="90vw"
      />
    ),
  });
  
  

export default function LazyFooter() {
  return (
    <div className="bg-[#EFF4F8] pt-10 flex flex-col items-center gap-4">
        {/* <BlogsBannerComponent></BlogsBannerComponent> */}
        <FooterComponent></FooterComponent>
      </div>
  );
}
